import { render } from "./DefaultTabPanel.vue?vue&type=template&id=1627663a"
import script from "./DefaultTabPanel.vue?vue&type=script&lang=js"
export * from "./DefaultTabPanel.vue?vue&type=script&lang=js"
script.render = render

export default script